import { CommonEnums } from '../../common.enums';

export class KafkaConsumer_Inst {
    kafkaconsumer_inst_id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    dxFlow_Id: number;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    disableFlg: string;
    src_ConnNm: string;
    tgt_ConnNm: string;
    retryEnabled: string;
    numOfRetryAttempts: number;
    retryWaitTime: number;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.kafkaconsumer_inst_id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.disableFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.src_ConnNm = CommonEnums.defaults.STRING_EMPTY;
        this.tgt_ConnNm = CommonEnums.defaults.STRING_EMPTY;
        this.retryEnabled = CommonEnums.defaults.STRING_VAL_NO;
        this.numOfRetryAttempts = 2;
        this.retryWaitTime = 60;
    }

    get PrimaryKey(): string {
        return this.kafkaconsumer_inst_id + '.' + this.dxFlow_Id;
    }

    copy(): KafkaConsumer_Inst {
        let kafkaConsumerTmp: KafkaConsumer_Inst = new KafkaConsumer_Inst();

        kafkaConsumerTmp.kafkaconsumer_inst_id = this.kafkaconsumer_inst_id;
        kafkaConsumerTmp.nm = this.nm;
        kafkaConsumerTmp.description = this.description;
        kafkaConsumerTmp.ver = this.ver;
        kafkaConsumerTmp.valid_Cd = this.valid_Cd;
        kafkaConsumerTmp.dxFlow_Id = this.dxFlow_Id;
        kafkaConsumerTmp.updateBy = this.updateBy;
        kafkaConsumerTmp.lastUpdateBy = this.lastUpdateBy;
        kafkaConsumerTmp.updateDt = this.updateDt;
        kafkaConsumerTmp.disableFlg = this.disableFlg;
        kafkaConsumerTmp.src_ConnNm = this.src_ConnNm;
        kafkaConsumerTmp.tgt_ConnNm = this.tgt_ConnNm;
        kafkaConsumerTmp.retryEnabled = this.retryEnabled;
        kafkaConsumerTmp.numOfRetryAttempts = this.numOfRetryAttempts;
        kafkaConsumerTmp.retryWaitTime = this.retryWaitTime;

        return kafkaConsumerTmp;
    }


    copyFrom(kafkaConsumerTmp: KafkaConsumer_Inst): void {
        this.kafkaconsumer_inst_id = kafkaConsumerTmp.kafkaconsumer_inst_id;
        this.nm = kafkaConsumerTmp.nm;
        this.description = kafkaConsumerTmp.description;
        this.ver = kafkaConsumerTmp.ver;
        this.valid_Cd = kafkaConsumerTmp.valid_Cd;
        this.dxFlow_Id = kafkaConsumerTmp.dxFlow_Id;
        this.updateBy = kafkaConsumerTmp.updateBy;
        this.lastUpdateBy = kafkaConsumerTmp.lastUpdateBy;
        this.updateDt = kafkaConsumerTmp.updateDt;
        this.disableFlg = kafkaConsumerTmp.disableFlg;
        this.src_ConnNm = kafkaConsumerTmp.src_ConnNm;
        this.tgt_ConnNm = kafkaConsumerTmp.tgt_ConnNm;
        this.retryEnabled = kafkaConsumerTmp.retryEnabled;
        this.numOfRetryAttempts = kafkaConsumerTmp.numOfRetryAttempts;
        this.retryWaitTime = kafkaConsumerTmp.retryWaitTime;
    }

    compare(kafkaConsumerTmp: KafkaConsumer_Inst): string {
        let kafkaConsumerString: string = this.toString(false);
        let kafkaConsumerTmpString: string = kafkaConsumerTmp.toString(false);

        if (kafkaConsumerString != kafkaConsumerTmpString) {
            return kafkaConsumerString + ', ' + kafkaConsumerTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "KafkaConsumer_Inst [kafkaconsumer_inst_id=" + this.kafkaconsumer_inst_id +
            ", nm=" + this.nm + ", description=" + this.description +
            ", ver=" + this.ver + ", updateBy=" + this.updateBy +", updateDt=" + this.updateDt +
            ", valid_Cd=" + this.valid_Cd + ", dxFlow_Id=" + this.dxFlow_Id + ", disableFlg=" + this.disableFlg +
            ",retryEnabled =" + this.retryEnabled +
            ",numOfRetryAttempts="+ this.numOfRetryAttempts +
           ", retryWaitTime= "+ this.retryWaitTime;
        if (isNotCompare) {
            str += ", lastUpdateBy=" + this.lastUpdateBy+
            ", src_ConnNm=" + this.src_ConnNm +
            ", tgt_ConnNm=" + this.tgt_ConnNm;

        }  
        str += ']';
        return str;
    }
}
